import React, { useCallback, useEffect, useRef, useState } from "react";
import PurchasingDocumentDialog from "./PurchasingDocumentDialog";
import { usePmsTheme } from "../../../Components/PmsThemeContext";

export function useStockApprovalDecision() {
  const { languageId } = usePmsTheme();
  const es = languageId === "es";
  const [request, setRequest] = useState(null);
  const [comments, setComments] = useState("");
  const resolver = useRef(null);
  const settle = useCallback((value) => {
    resolver.current?.(value);
    resolver.current = null;
    setRequest(null);
  }, []);
  useEffect(() => () => resolver.current?.(null), []);
  const ask = (action, code) => new Promise((resolve) => {
    resolver.current?.(null);
    resolver.current = resolve;
    setComments("");
    setRequest({ action, code });
  });
  const returning = request?.action === "return";
  const title = returning ? (es ? "Devolver con comentarios" : "Return with Comments") : (es ? "Rechazar solicitud" : "Reject request");
  return { ask, dialog: <PurchasingDocumentDialog isOpen={Boolean(request)} title={title}
    confirmLabel={title} onClose={() => settle(null)} onConfirm={() => comments.trim() && settle(comments.trim())}
    confirmDisabled={!comments.trim()} tone="warning" message={<>
      <p>{request?.code}</p>
      <label style={{ display: "grid", gap: 8 }}>{returning ? (es ? "Comentarios para corregir la solicitud" : "Comments for correcting the request") : (es ? "Motivo del rechazo" : "Rejection reason")}
        <textarea className="form-control" rows={4} required maxLength={4000} value={comments} onChange={(event) => setComments(event.target.value)} />
      </label>
      <p>{returning ? (es ? "El responsable podrá corregir y reenviar el mismo documento. Se conservará el historial." : "The responsible user can correct and resubmit the same document. Its history will be preserved.") : (es ? "El rechazo es definitivo. El motivo quedará registrado." : "Rejection is final. The reason will be recorded.")}</p>
    </>} /> };
}
